import { TabId } from '@lmn/common-search-widget';
import { FlightTravelClass } from '@lmn/common-search-widget/components/ClassButtons/services/types';
import type { Dates, PeopleData } from '@/app/components/search/utils';
import type { FlightClassType } from '@/app/components/search/utils/FlightClassType.ts';
import type { SearchInfoDetailData } from '@/app/search/types.ts';
import type { StaticCalendarValue } from '@lmn/common-search-widget/components/DateRangePicker/services/types';
import getCSWFlightClass from './adapters/getCSWFlightClass';
import getCSWDates from './adapters/getCSWDates';
import getCSWParticipants from './adapters/getCSWParticipants';
import { getCSWPlaceDestination, getCSWPlaceOrigin } from './adapters/getCSWPlace';
import type { DefaultValuesCSW } from './types';

type GetDefaultValuesProps = {
  defaultDates: Dates;
  searchInfoDetailData: SearchInfoDetailData;
  defaultPeopleData: PeopleData;
  selectedItemId?: number;
  defaultFlightClass?: FlightClassType;
  departureIntervals?: string;
  defaultStayDates?: StaticCalendarValue;
};
const getDefaultValues = ({
  defaultDates,
  searchInfoDetailData,
  defaultPeopleData,
  defaultFlightClass,
  departureIntervals,
  defaultStayDates,
}: GetDefaultValuesProps): DefaultValuesCSW => {
  const fromPlace = getCSWPlaceOrigin(searchInfoDetailData);
  const toPlace = getCSWPlaceDestination(searchInfoDetailData);
  const dates = getCSWDates(defaultDates, departureIntervals);
  const participants = getCSWParticipants(defaultPeopleData);
  const flightClass = defaultFlightClass ? getCSWFlightClass(defaultFlightClass) : FlightTravelClass.AnyClass;

  return {
    [TabId.DynamicPackage]: {
      fromPlace,
      toPlace,
      dates,
      participants,
      stayDates: defaultStayDates,
      class: flightClass,
      isPartialStay: !!defaultStayDates,
    },
    [TabId.Train]: { fromPlace, toPlace, dates, participants },
    [TabId.Hotel]: { place: toPlace, dates, participants },
    [TabId.Flight]: undefined as never,
  };
};

export default getDefaultValues;
